<div class="row mt-2 mb-2">
  <div class="col">
    <div class="border p-2" *ngIf="servicePackageData">

      <div class="row no-gutters bg-light">
        <div class="col-lg-9 col-md-9 col-sm-9 col-8 p-2">
          <div>
            <span>{{servicePackageData.name}}</span> &nbsp; &nbsp;
            <small>
              <button
                [ngClass]="{'true': 'btn-success', 'false': 'btn-danger'}[!servicePackageData.inUse && !servicePackageData.isActive]"
                class="btn btn-sm rounded-pill txt-small pt-0 pb-0">
                <span *ngIf="servicePackageData.inUse || servicePackageData.isActive">In-Use</span>
                <span *ngIf="!servicePackageData.inUse && !servicePackageData.isActive">Not-In-Use</span></button>
            </small>
          </div>
          <div><small><span class="text-secondary"><i>{{servicePackageData.description}}</i></span></small>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-4 text-right p-2">
          <button type="submit" *ngIf="isShowEditbtn"
            [disabled]="servicePackageData.inUse || servicePackageData.isActive"
            class="btn btn-primary btn-sm pt-0 pb-0" (click)="editCLicked()" data-toggle="tooltip"
            data-placement="right" title="Edit">EDIT</button>
          <i class="fas fa-times pointer ml-2" (click)="closeClicked()" data-toggle="tooltip" data-placement="right"
            title="Close"></i>
          <!-- <button type="button" class="btn btn-light  ml-2" (click)="closeClicked()" data-toggle="tooltip"
            data-placement="right" title="Close"></button> -->
        </div>
      </div>


      <div class="scroll-view">
          <div class="mt-2" *ngIf="servicePackageData.inUse && servicePackageData.usageCount != null">
              <div class="mb-2"><small class="text-secondary"><b>Connected Vehicles : </b> {{servicePackageData.usageCount}}
                  </small></div>
          </div>

        <div class="mt-2" *ngIf="servicePackageData.services">
          <div class="mb-2"><small class="text-secondary"><b>Package Services : </b></small></div>

          <div class="mb-4" *ngFor="let serviceData of servicePackageData.services; let serviceIndex = index">

            <div class="row no-gutters">
              <div class="col-3">
                <small><b>{{serviceIndex+1}}.</b>&nbsp;&nbsp;<span>{{serviceData.name | customText}}</span></small>
              </div>
              <div class="col-9">
                <small><span class="text-secondary">Category : </span>{{serviceData.category | customText}}</small>
              </div>
            </div>
            <div><small><span class="text-secondary"><i>{{serviceData.description}}</i></span></small></div>

            <div class="mt-2 mb-2"><small class="text-secondary"><b>Permission</b></small></div>

            <div class="row no-gutters">
              <div class="col-3">
                <small>
                  <span class="text-secondary">Personal Data : </span>
                  <span *ngIf="serviceData.permission.personalData">Yes</span>
                  <span *ngIf="!serviceData.permission.personalData">No</span>
                </small>
              </div>
              <div class="col-9">
                <small>
                  <span class="text-secondary">Permission Dependency : </span>
                  <span>{{serviceData.permission.permissionDependency | customText}}</span>
                </small>
              </div>
            </div>

            <div class="mt-2" *ngIf="serviceData.serviceApis">
              <div><small class="text-secondary"><b>Service APIs</b></small></div>

              <ul>
                <li *ngIf="serviceData.serviceApis.rest">
                  <div class="mt-1 mb-1"><small class="text-secondary"><b>Rest APIs</b></small></div>
                  <ul>
                    <li>
                      <div class="mb-1" *ngFor="let api of serviceData.serviceApis.rest.apis">
                        <div><small class="w-break"><span
                              class="text-secondary">{{api.type}}&nbsp;</span><span>{{api.url}}</span></small></div>
                        <div><small class="w-break"><span><i>{{api.description}}</i></span></small>
                        </div>
                      </div>
                      <div class="row no-gutters">
                        <div class="col-3">
                          <small><span class="text-secondary">Auth Type :
                            </span><span>{{serviceData.serviceApis.rest.authScheme.authType | customText}}</span></small>
                        </div>
                        <div class="col-9">
                          <small><span class="text-secondary">Auth Fields :
                            </span><span
                              *ngFor="let authField of serviceData.serviceApis.rest.authScheme.authFields">{{authField | customText}}&nbsp;&nbsp;</span></small>
                        </div>
                      </div>

                    </li>
                  </ul>
                </li>
                <li *ngIf="serviceData.serviceApis.notifications">
                  <div class="mb-1 mt-1"><small class="text-secondary"><b>Notification</b></small></div>
                  <ul *ngFor="let notification of serviceData.serviceApis.notifications">
                    <li>
                      <div><small>{{notification.subscriptionType | customText}}</small></div>
                      <div class="mb-1" *ngFor="let api of notification.apis">
                        <div><small><span
                              class="text-secondary">{{api.type}}&nbsp;</span><span>{{api.url}}</span></small>
                        </div>
                        <div><small><span><i>{{api.description}}</i></span></small>
                        </div>
                      </div>
                      <div class="row no-gutters">
                        <!-- <div class="col-3">
                          <small>{{notification.subscriptionType}}</small>
                        </div> -->
                        <div class="col-3">
                          <small><span class="text-secondary">Auth Type :
                            </span><span>{{notification.authScheme.authType | customText}}</span></small>
                        </div>
                        <div class="col-6">
                          <small><span class="text-secondary">Auth Fields :
                            </span><span
                              *ngFor="let authField of notification.authScheme.authFields">{{authField | customText}}&nbsp;&nbsp;</span></small>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li *ngIf="serviceData.serviceApis.pubSub">
                  <div class="mb-1 mt-1"><small class="text-secondary"><b>Pubsub</b></small></div>
                  <ul>
                    <li>
                      <div class="mb-1" *ngFor="let api of serviceData.serviceApis.pubSub.apis">
                        <div><small><span
                              class="text-secondary">{{api.type}}&nbsp;</span><span>{{api.url}}</span></small>
                        </div>
                        <div><small><span><i>{{api.description}}</i></span></small>
                        </div>
                      </div>
                      <div class="row no-gutters">
                        <div class="col-3">
                          <small><span class="text-secondary">Auth Type :
                            </span><span>{{serviceData.serviceApis.pubSub.authScheme.authType | customText}}</span></small>
                        </div>
                        <div class="col-9">
                          <small><span class="text-secondary">Auth Fields :
                            </span><span
                              *ngFor="let authField of serviceData.serviceApis.pubSub.authScheme.authFields">{{authField | customText}}&nbsp;&nbsp;</span></small>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <!--               
            <div class="mt-2" *ngIf="servicePackageData.isDefaultRatePlan && serviceData.serviceRatePlans">
              <div class="mb-1 mt-1"><small class="text-secondary"><b>Service Rate Plans</b></small></div>
              <ul class="mb-1" *ngFor="let plan of serviceData.ratePlans">
                <li>
                  <div *ngIf="plan.ratePlanType != 'TRANSACTION_BASED'"><small
                      class="text-secondary"><b>{{plan.ratePlanType}}</b></small></div>

                  <div *ngIf="plan.ratePlanType == 'TRANSACTION_BASED'">
                    <div><small class="w-break"><span
                          class="text-secondary">{{plan.api.type}}&nbsp;</span><span>{{plan.api.url}}</span></small>
                    </div>

                    <div><small class="w-break"><span><i>{{plan.api.description}}</i></span></small>
                    </div>
                    <div><small class="w-break"><span class="text-secondary">Unit Fee :
                        </span><span>{{plan.unitFee.currency}}&nbsp;{{plan.unitFee.value}}</span></small>
                    </div>
                  </div>

                  <div *ngIf="plan.ratePlanType == 'VOLUME_USAGE_BASED'">
                    <div div class="row no-gutters">
                      <div class="col-3">
                        <small class="w-break"><span class="text-secondary">Volume
                            :
                          </span><span>{{plan.volume}}&nbsp;{{plan.volumeUsageUnit}}</span></small>
                      </div>
                      <div class="col-9">
                        <small class="w-break"><span class="text-secondary">Unit Fee :
                          </span><span>{{plan.unitFee.currency}}&nbsp;{{plan.unitFee.value}}</span></small>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="plan.ratePlanType == 'LICENSE_BASED'">
                    <div class="row no-gutters">
                      <div class="col-3">
                        <small class="w-break"><span class="text-secondary">License
                            Type
                            :
                          </span><span>{{plan.licenseType}}</span></small>
                      </div>
                      <div class="col-9">
                        <small class="w-break"><span class="text-secondary">Unit Fee :
                          </span><span>{{plan.unitFee.currency}}&nbsp;{{plan.unitFee.value}}</span></small>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div> -->
          </div>
        </div>


        <div class="mt-3" *ngIf="servicePackageData.ratePlans">
          <div class="mb-2"><small class="text-secondary"><b>Rate Plans : </b></small></div>
          <ul class="mb-3" *ngFor="let ratePlan of servicePackageData.ratePlans">

            <!-- default rate plan  -->

            <li>
              <div *ngIf="ratePlan.type=='SERVICE_RATE_PLAN'">
                <!-- <div class="row no-gutters" *ngIf="ratePlan.ratePlanType != 'TRANSACTION_BASED'">
                  <div class="col-4" >
                    <small><span>{{ratePlan.ratePlanType | customText}}</span></small>
                  </div>
                  <div class="col-8">
                    <small><span class="text-secondary">Type :
                      </span><span>{{ratePlan.type | customText}}</span></small>
                  </div>
                </div> -->
                <div *ngIf="ratePlan.ratePlanType != 'TRANSACTION_BASED'"><small
                    class="text-secondary"><b>{{ratePlan.ratePlanType}}</b></small></div> 

                <div *ngIf="ratePlan.ratePlanType == 'TRANSACTION_BASED'">
                  <div><small class="w-break"><span
                        class="text-secondary">{{ratePlan.api.type}}&nbsp;</span><span>{{ratePlan.api.url}}</span></small>
                  </div>

                  <div><small class="w-break"><span><i>{{ratePlan.api.description}}</i></span></small>
                  </div>
                  <div><small class="w-break"><span class="text-secondary">Unit Fee :
                      </span><span>{{ratePlan.unitFee.currency}}&nbsp;{{ratePlan.unitFee.value}}</span></small>
                  </div>
                </div>

                <div *ngIf="ratePlan.ratePlanType == 'VOLUME_USAGE_BASED'">
                  <div div class="row no-gutters">
                    <div class="col-3">
                      <small class="w-break"><span class="text-secondary">Volume
                          :
                        </span><span>{{ratePlan.volume}}&nbsp;{{ratePlan.volumeUsageUnit}}</span></small>
                    </div>
                    <div class="col-9">
                      <small class="w-break"><span class="text-secondary">Unit Fee :
                        </span><span>{{ratePlan.unitFee.currency}}&nbsp;{{ratePlan.unitFee.value}}</span></small>
                    </div>
                  </div>
                </div>

                <div *ngIf="ratePlan.ratePlanType == 'LICENSE_BASED'">
                  <div class="row no-gutters">
                    <div class="col-3">
                      <small class="w-break"><span class="text-secondary">License
                          Type
                          :
                        </span><span>{{ratePlan.licenseType}}</span></small>
                    </div>
                    <div class="col-9">
                      <small class="w-break"><span class="text-secondary">Unit Fee :
                        </span><span>{{ratePlan.unitFee.currency}}&nbsp;{{ratePlan.unitFee.value}}</span></small>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Default service rate plan ends -->
              <div *ngIf="ratePlan.type=='SERVICE_PACKAGE_RATE_PLAN'">
                <div class="row no-gutters">
                  <div class="col-4">
                    <small><span>{{ratePlan.ratePlanType | customText}}</span></small>
                  </div>
                  <div class="col-8">
                    <small><span class="text-secondary">Type :
                      </span><span>{{ratePlan.type | customText}}</span></small>
                  </div>
                </div>

                <div *ngIf="ratePlan.ratePlanType == 'LICENSE_BASED'"><small><span class="text-secondary">License Type :
                    </span><span>{{ratePlan.licenseType | customText}}</span></small></div>

                <div *ngIf="ratePlan.ratePlanType == 'FLAT_RATE'">
                  <div class="mt-1 mb-1"><small class="text-secondary"><b>Rates: </b></small></div>
                  <ul *ngFor="let rate of ratePlan.rates">
                    <li>
                      <div class="row no-gutters">
                        <div class="col-4">
                          <small><span>{{rate.serviceName | customText}}</span></small>
                        </div>
                        <div class="col-8">
                          <small class="w-break"><span class="text-secondary">Unit Fee :
                            </span><span>{{rate.unitFee.currency}}&nbsp;{{rate.unitFee.value}}</span></small>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div *ngIf="ratePlan.ratePlanType == 'LICENSE_BASED'">
                  <div class="mt-1 mb-1"><small class="text-secondary"><b>Rate Slabs: </b></small></div>
                  <ul *ngFor="let slab of ratePlan.rateSlabs">
                    <li>
                      <div class="row no-gutters">
                        <div class="col-4">
                          <small><span class="text-secondary">Min - Max : </span><span>{{slab.minimum}} -
                              {{slab.maximum}}</span></small>
                        </div>
                        <div class="col-8">
                          <small><span class="text-secondary">Unit Fee :
                            </span><span>{{slab.unitFee.currency}}&nbsp;{{slab.unitFee.value}}</span></small>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div *ngIf="ratePlan.ratePlanType == 'HYBRID'">
                  <div class="mt-1 mb-1"><small class="text-secondary"><b>Rate Plans: </b></small></div>
                  <ul *ngFor="let plan of ratePlan.ratePlans">
                    <li>

                      <div class="mt-1 mb-1"><small><span>{{plan.ratePlanType | customText}}</span></small></div>

                      <div *ngIf="plan.ratePlanType == 'FLAT_RATE'">
                        <div><small class="text-secondary"><b>Rates: </b></small></div>
                        <ul *ngFor="let rate of plan.rates">
                          <li>
                            <div class="row no-gutters">
                              <div class="col-4">
                                <small><span>{{rate.serviceName | customText}}</span></small>
                              </div>
                              <div class="col-8">
                                <small class="w-break"><span class="text-secondary">Unit Fee :
                                  </span><span>{{rate.unitFee.currency}}&nbsp;{{rate.unitFee.value}}</span></small>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div *ngIf="plan.ratePlanType == 'LICENSE_BASED'">

                        <div><small><span class="text-secondary">License Type :
                            </span><span>{{plan.licenseType | customText}}</span></small></div>

                        <div><small class="text-secondary"><b>Rate Slabs: </b></small></div>

                        <ul *ngFor="let slab of plan.rateSlabs">
                          <li>
                            <div class="row no-gutters">
                              <div class="col-4">
                                <small><span class="text-secondary">Min - Max : </span><span>{{slab.minimum}} -
                                    {{slab.maximum}}</span></small>
                              </div>
                              <div class="col-8">
                                <small><span class="text-secondary">Unit Fee :
                                  </span><span>{{slab.unitFee.currency}}&nbsp;{{slab.unitFee.value}}</span></small>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div *ngIf="plan.ratePlanType == 'USAGE_BASED'">
                        <div><small class="text-secondary"><b>Rate Slabs: </b></small></div>
                        <ul *ngFor="let slab of plan.rateSlabs">
                          <li>
                            <div class="row no-gutters">
                              <div class="col-4">
                                <small><span class="text-secondary">Min - Max : </span><span>{{slab.minimum}} -
                                    {{slab.maximum}}</span></small>
                              </div>
                              <div class="col-8">
                                <small><span class="text-secondary">Unit Fee :
                                  </span><span>{{slab.unitFee.currency}}&nbsp;{{slab.unitFee.value}}</span></small>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>


        <ul class="mt-3" *ngIf="servicePackageData.discounts">
          <li>
            <div><small class="text-secondary"><b>Discounts : </b></small></div>
            <ul class="mb-1" *ngFor="let discount of servicePackageData.packageRatePlan.discounts">
              <li>

                <div class="row no-gutters">
                  <div class="col-4">
                    <small>
                      <span>{{discount.brand}}</span>
                      &nbsp;&nbsp;<span>{{discount.model}}</span>
                      &nbsp;&nbsp;<span>{{discount.trim}}</span>
                    </small>
                  </div>
                  <div class="col-8">
                    <small><span class="text-secondary">Discount : </span><span>{{discount.discount}} %</span></small>
                  </div>
                </div>

                <!-- <div class="d-inline-block">
                  <small><span class="text-secondary">Brand : </span><span>{{discount.brand}}</span></small>
                </div>
                <div class="d-inline-block ml-2">
                  <small><span class="text-secondary">Model : </span><span>{{discount.model}}</span></small>
                </div>
                <div class="d-inline-block ml-2" *ngIf="discount.trim">
                  <small><span class="text-secondary">Trim : </span><span>{{discount.trim}}</span></small>
                </div>
                <div class="d-inline-block ml-2">
                  <small><span class="text-secondary">Discount : </span><span>{{discount.discount}} %</span></small>
                </div> -->
                <!-- <div class="row no-gutters">
                  <div class="col-3">
                    <small><span class="text-secondary">Brand : </span><span>{{discount.brand}}</span></small>
                  </div>
                  <div class="col-9">
                    <small><span class="text-secondary">Model : </span><span>{{discount.model}}</span></small>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col-3">
                    <small><span class="text-secondary">Trim : </span><span>{{discount.trim}}</span></small>
                  </div>
                  <div class="col-9">
                    <small><span class="text-secondary">Discount : </span><span>{{discount.discount}} %</span></small>
                  </div>
                </div> -->
              </li>
            </ul>
          </li>
        </ul>

        <!-- <div class="text-center">
          <button type="button" class="btn btn-light" (click)="closeClicked()">CLOSE</button>
          <button type="submit" *ngIf="isShowEditbtn" [disabled]="servicePackageData.inUse || servicePackageData.isActive"
            class="btn btn-primary ml-2" (click)="editCLicked()">EDIT</button>
        </div> -->
      </div>



    </div>
  </div>
</div>